// resources/js/src/components/community/components/profile/PhotosGrid.tsx
import { Icon } from "@iconify/react";
import { PhotosGridProps } from "../interface/CommunityProfile";

type Props = PhotosGridProps & {
  onSeeAll?: () => void;
};

export default function PhotosGrid({
  photos,
  title = "Photos",
  showSeeAll = true,
  onSeeAll,
}: Props) {
  const displayPhotos = photos.slice(0, 6);

  return (
    <div className="bg-white dark:bg-deepSlate rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 transition-shadow duration-300 hover:shadow-md">
      {/* ===== Header ===== */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon
            icon="mdi:image-multiple-outline"
            className="text-primary-600 dark:text-primary-400 text-xl"
          />
          <h2 className="text-lg font-bold text-gray-900 dark:text-white">
            {title}
          </h2>
        </div>
        {showSeeAll && (
          <button
            onClick={onSeeAll}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 hover:bg-primary-50 dark:hover:bg-primary-900/20 px-2.5 py-1.5 rounded-lg transition-all duration-200 active:scale-[0.97]"
          >
            See All
            <Icon icon="mdi:chevron-right" className="text-base" />
          </button>
        )}
      </div>

      {/* ===== Grid ===== */}
      {displayPhotos.length > 0 ? (
        <div className="grid grid-cols-3 gap-1.5">
          {displayPhotos.map((photo) => (
            <button
              key={photo.id}
              onClick={onSeeAll}
              className="aspect-square relative overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800 group ring-0 hover:ring-2 hover:ring-primary-500 transition-all duration-200"
            >
              <img
                src={photo.url}
                alt="Photo"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                <Icon
                  icon="mdi:magnify-plus-outline"
                  className="text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                />
              </div>
            </button>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500 dark:text-gray-400 italic text-center py-4">
          No photos to show yet.
        </p>
      )}
    </div>
  );
}